import React from 'react';
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Chip,
  Collapse,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { format } from 'date-fns';
import Iconify from '../../../../components/iconify';
import { HeaderSubTitle, TaskRow, TaskTableCell } from './styles/plannedVsActualReportStyles';
import { formatSecondesToHourMinute } from '../../../../utils/formatTime';
import { StatusChip } from './StatusChip';

export const TasksForEmployee = ({ member, startDate, endDate }) => (
  <TableRow>
    <TableCell style={{ padding: 0 }} colSpan={5}>
      <Box sx={{ pl: 6 }}>
        <Table size="small" sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '50px' }} />
              <TableCell sx={{ width: '30%' }}>Task Name</TableCell>
              <TableCell sx={{ width: '12%' }}>Status</TableCell>
              <TableCell sx={{ width: '8%' }} align="right">
                Progress
              </TableCell>
              <TableCell sx={{ width: '25%' }} align="right">
                Consumed Efforts
                {startDate && endDate && (
                  <HeaderSubTitle>
                    {format(new Date(startDate), 'dd-MM-yyyy')} to {format(new Date(endDate), 'dd-MM-yyyy')}
                  </HeaderSubTitle>
                )}
              </TableCell>
              <TableCell sx={{ width: '25%' }} align="right">
                Planned Efforts
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {member.tasks?.map((task, taskIndex) => (
              <React.Fragment key={taskIndex}>
                <TaskRow>
                  <TableCell sx={{ pl: 1 }} />
                  <TaskTableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Iconify icon="material-symbols:task-rounded" />
                      <Typography noWrap>{task.taskName}</Typography>
                    </Box>
                  </TaskTableCell>
                  <TaskTableCell>
                    <StatusChip status={task.status} type="status" />
                  </TaskTableCell>
                  <TaskTableCell align="right">
                    <StatusChip
                      status={Math.round((task.consumedSeconds / task.plannedSeconds) * 100) || 0}
                      type="progress"
                    />
                  </TaskTableCell>
                  <TaskTableCell align="right">{formatSecondesToHourMinute(task.consumedSeconds)}</TaskTableCell>
                  <TaskTableCell align="right">{formatSecondesToHourMinute(task.plannedSeconds)}</TaskTableCell>
                </TaskRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableCell>
  </TableRow>
);
